<template>
	<div class="curriculumVita">
		<div class="libox" v-for="(item,index) of list" :key="index" @click="currDe(item)">
			<div class="li" :style="{'padding-bottom':type==1?'18px':'28px'}">
				<div v-if="type==1" class="left">
					<div class="leftAvatar">
						<div class="avatarCon">
							<el-image :src="item.avatar||require('@/static/avatar.png')" fit="cover" class="photo"></el-image>
							<img v-if="item.sex==0" src="@/static/male.png" class="female" />
							<img v-else src="@/static/female.png" class="female" />
						</div>
						<div class="pay">
							{{`${parseFloat((item.salary_min/1000).toFixed(1))}-${parseFloat((item.salary_max/1000).toFixed(1))}k`}}
						</div>
					</div>
					<div class="info">
						<div class="name">
							{{item.user_name||'未填写资料'}}
						</div>
						<div class="year">
							{{item.work_year||'工作经验未知'}} · {{item.ages?item.ages+'岁':'年龄未知'}} · {{item.qualifications||'学历未知'}}
						</div>
						<div class="position">
							<img src="@/static/coll.png" class="icon" />
							<div class="">
								{{item.position_type}}
							</div>
						</div>
						<div class="adv">
							{{item.personal_evaluation}}
						</div>
					</div>
				</div>
				
				<div v-if="type==2" class="left">
					<div class="leftAvatar">
						<div class="avatarCon">
							<el-image :src="item.other_user.avatar||require('@/static/avatar.png')" fit="cover" class="photo"></el-image>
						</div>
					</div>
					<div class="info">
						<div class="name">
							{{item.other_user.user_name||'未填写资料'}}
						</div>
						<div class="year">
							{{item.other_user.phone.slice(0, 3) + '****' + item.other_user.phone.slice(7)}}
						</div>
					</div>
				</div>
				
				<div v-if="type==3" class="left">
					<div class="leftAvatar">
						<div class="avatarCon">
							<el-image :src="item.user.avatar||require('@/static/avatar.png')" fit="cover" class="photo"></el-image>
							<!-- <img v-if="item.sex==0" src="@/static/male.png" class="female" />
							<img v-else src="@/static/female.png" class="female" /> -->
						</div>
						<div  class="pay">
							{{`${parseFloat((item.position.salary_min/1000).toFixed(1))}-${parseFloat((item.position.salary_max/1000).toFixed(1))}k`}}
						</div>
					</div>
					<div class="info">
						<div class="name">
							{{item.user.user_name}}
						</div>
						<div class="year">
							{{item.position.tag_name_year}} · {{item.position.address.split('-')[1]}} · {{item.position.tag_name_qualifications}}
						</div>
						<div class="position">
							<img src="@/static/coll.png" class="icon" />
							<div class="">
								{{item.position.position_name}}
							</div>
						</div>
					</div>
				</div>
				
				<div v-if="type==4" class="left">
					<div class="leftAvatar">
						<div class="avatarCon">
							<el-image :src="item.user.avatar||require('@/static/avatar.png')" fit="cover" class="photo"></el-image>
							<img v-if="item.user.sex==0" src="@/static/male.png" class="female" />
							<img v-else src="@/static/female.png" class="female" />
						</div>
						<div class="pay">
							{{`${parseFloat((item.user.salary_min/1000).toFixed(1))}-${parseFloat((item.user.salary_max/1000).toFixed(1))}k`}}
						</div>
					</div>
					<div class="info">
						<div class="name">
							{{item.user.user_name||'未填写资料'}}
						</div>
						<div class="year">
							{{item.user.work_year||'工作经验未知'}} · {{item.user.ages?item.user.ages+'岁':'年龄未知'}} · {{item.user.qualifications||'学历未知'}}
						</div>
						<div class="position">
							
							<div class="">
								{{item.user.phone.slice(0, 3) + '****' + item.user.phone.slice(7)}}
							</div>
						</div>
					</div>
				</div>
				
				<div v-if="type==1" class="center">
					<template v-if="item.work.length>0">
						<div v-if="i<3" v-for="(tab,i) of item.work" :key="i" class="centerLi">
							<img src="@/static/yearIcon.png" class="icon"/>
							<div class="time">
								{{tab.start_time}}至{{tab.end_time}}
							</div>
							<div class="name">
								{{tab.belong_to}} · {{tab.position}}
							</div>
						</div>
					</template>
					<!-- <div v-if="item.work.length>0" style="min-height: 90px;">
						
					</div> -->
					<div v-if="item.education.length>0" class="centerLi">
						<img src="@/static/eduIcon.png" class="icon" />
						<div class="time">
							{{item.education[0].start_time}}至{{item.education[0].end_time}}
						</div>
						<div class="name">
							{{item.education[0].belong_to}} · {{item.education[0].position}}
						</div>
					</div>
				</div>
				
				<div v-if="type==5" class="left">
					<div class="leftAvatar">
						<div class="avatarCon" style="margin-bottom: 0;">
							<el-image :src="(join==1?item.user:item).en_avatar||require('@/static/avatar.png')" fit="cover" class="photo"></el-image>
						</div>
					</div>
					<div class="info">
						<div class="name">
							{{(join==1?item.user:item).en_user_name||'未填写资料'}}
						</div>
						<div class="year">
							{{(join==1?item.user:item).phone.slice(0, 3) + '****' + (join==1?item.user:item).phone.slice(7)}}
						</div>
					</div>
				</div>
				
				
				<el-button type="primary" v-if="type!=5" class="button" @click.stop="toChat(item)">立即沟通</el-button>
				<div v-if="type==5" class="rightbox">
					<template v-if="join==1">
						<div class="titlebox">申请时间：{{item.created_at}}</div>
						<div style="text-align: right;">
							<el-button type="danger" size="small" @click.stop="confirmApply(item.id,2)">驳回申请</el-button>
							<el-button type="primary" size="small" @click.stop="confirmApply(item.id,1)">通过申请</el-button>
						</div>
					</template>
					<template v-else>
						<div class="titlebox">{{item.en_account_type==2?'管理员':'员工'}}</div>
						<div style="text-align: right;" v-if="info.en_account_type==2&&item.id!=info.id">
							<el-button type="danger" size="small" @click.stop="removeStaff(item.id)">移除公司</el-button>
							<el-button type="primary" size="small" v-if="item.en_account_type!=2" @click.stop="changeAdmin(item.id)">转让管理员</el-button>
						</div>
					</template>
				</div>
				
			</div>
			<div class="linebox" v-if="type==1">
				<div class="text">准聘AI基于</div>
				<div class="text mid"><span>{{item.position.position_name}}</span></div>
				<div class="text">推送</div>
			</div>
			<div class="linebox" v-if="type==5&&join==1">
				<div class="text">申请原因：<span>{{item.remarks}}</span></div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		name:'curriculumVita',
		props:['list','type','join','info'],
		data() {
			return {
				userinfo:''
			}
		},
		created() {

		},
		methods: {
			removeStaff(id){
				this.$confirm('此操作将从公司移除此用户，是否继续？', '移除公司', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$axios.post('/api/client/ES/removeStaff',{user_id:id}).then(res=>{
						if(res.code==200){
							this.$eltips(res.msg,'success')
							this.$emit('staffConfirm',true)
						}else{
							this.$eltips(res.msg,'error')
						}
					})
				}).catch(() => {});
			},
			changeAdmin(id){
				this.$confirm('此操作将公司管理员转让给此用户，是否继续？', '转让管理一', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$axios.post('/api/client/ES/transferenceSAdmin',{new_user_id:id}).then(res=>{
						if(res.code==200){
							this.$eltips(res.msg,'success')
							this.$emit('staffConfirm',true)
						}else{
							this.$eltips(res.msg,'error')
						}
					})
				}).catch(() => {});
			},
			confirmApply(id,type){
				const url = '/api/client/ES/recruiterApprove'
				let data = {id:id,type:type}
				if(type==1){
					this.$confirm('此操作将通过该用户加入企业的申请, 是否继续?', '通过申请', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$axios.post(url,data).then(res=>{
							if(res.code==200){
								this.$eltips(res.msg,'success')
								this.$emit('applyConfirm',true)
							}else{
								this.$eltips(res.msg,'error')
							}
						})
					}).catch(() => {});
				}else{
					this.$prompt('请输入驳回原因', '驳回申请', {
					    confirmButtonText: '确定',
					    cancelButtonText: '取消',
						inputType:'textarea',
					    inputValidator(value){
					    	if(!value) return '驳回原因不能为空'
					    	if(value.replace(/\s/g,'').length<1) return '驳回原因不能为空'
					    },
					}).then(({ value }) => {
						data.remarks = value
						this.$axios.post(url,data).then(res=>{
							if(res.code==200){
								this.$eltips(res.msg,'success')
								this.$emit('applyConfirm',true)
							}else{
								this.$eltips(res.msg,'error')
							}
						})
					}).catch(() => {});
				}
			},
			toChat(item){
				this.$emit('chatConfirm',item)
			},
			currDe(item){
				if(this.type==1){
					this.$router.push({ name: 'resumeDe', query: { id: item.id,type:1 } });
				}
				if(this.type==2){
					this.$router.push({ name: 'resumeDe', query: { id: item.other_user.id,type:2 } });
				}
				if(this.type==3){
					this.$router.push({ name: 'resumeDe', query: { id: item.user.id,type:2 } });
				}
				if(this.type==4){
					this.$router.push({ name: 'resumeDe', query: { id: item.user.id,type:1 } });
				}	
				if(this.type==5) return;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.libox{
		margin-bottom: 24px;
		border-radius: 16px;
		background-color: #FFF;
		overflow: hidden;
		&:last-child{
			margin-bottom: 0;
		}
	}
	.li {
		padding: 28px;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		cursor: pointer;
		.left {
			display: flex;
			align-items: flex-start;
	
			.leftAvatar {
				margin-right: 19px;
				
				.avatarCon {
					width: 58px;
					height: 58px;
					position: relative;
					margin-bottom: 12px;
	
					.photo {
						width: 100%;
						height: 100%;
						border-radius: 50%;
					}
	
					.female {
						position: absolute;
						right: 0;
						bottom: 0;
						width: 16px;
						height: 16px;
					}
				}
	
				.pay {
					color: #9B6CFF;
					font-size: 15px;
					text-align: center;
				}
			}
	
			.info {
				font-size: 14px;
				color: #151515;
	
				.name {
					font-size: 18px;
					margin-bottom: 10px;
					font-weight: bold;
				}
	
				.year {
					margin-bottom: 10px;
				}
	
				.position {
					display: flex;
					align-items: center;
					margin-bottom: 10px;
	
					.icon {
						width: 16px;
						height: 16px;
						margin-right: 4px;
					}
				}
	
				.adv {
					width: 417px;
				}
			}
		}
	
		.center {
			// padding-top: 20px;
			flex: 1;
			.centerLi {
				display: flex;
				align-items: center;
				margin-bottom: 18px;
				&:last-child{
					margin-bottom: 0;
				}
	
				.icon {
					width: 16px;
					height: 16px;
					margin-right: 10px;
				}
	
				.time {
					color: #5E5E5E;
					font-size: 13px;
					// width: 105px;
					margin-right: 38px;
				}
	
				.name {
					color: #181C2E;
					font-size: 16px;
					width: 262px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
		}
	
	    .button{
			width: 128px;
			height: 38px;
			border-radius: 8px;
			font-size: 14px;
		}
	
		.rightbox{
			display: flex;
			height: 60px;
			flex-direction: column;
			justify-content: space-between;
			.titlebox{
				text-align: right;
				font-size: 14px;
			}
		}
	}
	.linebox{
		border-top: 1px solid #e3e3e3;
		padding:12px 28px 18px;
		background: #FFF;
		.text{
			display: inline-block;
			font-size: 15px;
			line-height: 1;
			vertical-align: middle;
		}
		.mid{
			max-width: calc(100% - 6em - 2em);
			color: #51A190;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}
	
</style>